function slideUp(target, duration = 500) {
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = '0px';
  target.style.paddingTop = '0px';
  target.style.paddingBottom = '0px';
  target.style.marginTop = '0px';
  target.style.marginBottom = '0px';
}

function slideDown(target, duration = 500) {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;

  const height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = '0px';
  target.style.paddingTop = '0px';
  target.style.paddingBottom = '0px';
  target.style.marginTop = '0px';
  target.style.marginBottom = '0px';
  target.offsetHeight;

  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
}

function resetAccordionStyles(target) {
  target.style.removeProperty('height');
  target.style.removeProperty('overflow');
  target.style.removeProperty('transition-property');
  target.style.removeProperty('transition-duration');
  target.style.removeProperty('transition-timing-function');
  target.style.removeProperty('box-sizing');
}

document.querySelectorAll('.product__accordion .accordion__content').forEach((content) => {
  const details = content.closest('details');
  const summary = details ? details.querySelector('summary') : null;
  if (!details || !summary) return;

  const duration = 500;
  let animating = false;

  summary.addEventListener('click', (event) => {
    event.preventDefault();
    if (animating) return;
    animating = true;

    if (details.hasAttribute('open')) {
      slideUp(content, duration);
      window.setTimeout(() => {
        details.removeAttribute('open');
        resetAccordionStyles(content);
        animating = false;
      }, duration);
    } else {
      details.setAttribute('open', '');
      slideDown(content, duration);
      window.setTimeout(() => {
        resetAccordionStyles(content);
        animating = false;
      }, duration);
    }
  });
});
